import React from 'react';
import Hero from './components/about-us/chancellor/Hero';
import Main from './components/about-us/chancellor/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Chancellor = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default Chancellor;